import styles from 'sections/aboutUs/conceptDescription/conceptDescription.module.css';
import generalStyles from 'index.module.css';

import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { OptimizedImg } from 'components/optimizedImg/OptimizedImg';
import { AnimatedImg } from 'components/animatedImg/AnimatedImg';
import {
    useGetConceptDescriptionSteps,
    useGetDefiningFeatureSteps,
} from 'sections/aboutUs/conceptDescription/conceptDescription.hooks';
import { conceptDescriptionPics } from 'sections/aboutUs/conceptDescription/conceptDescription.util';

export const ConceptDescription = () => {
    const { t } = useTranslation();
    const conceptDescriptionSteps = useGetConceptDescriptionSteps();
    const definingFeatures = useGetDefiningFeatureSteps();
    const pics = conceptDescriptionPics();

    return (
        <section
            id="section-about-us-concept-description"
            className={`${generalStyles.heightAuto} ${styles.conceptDescriptionSection}`}
        >
            <Element name="conceptDescription">
                <div className={generalStyles.container}>
                    <div className={styles.conceptDescription}>
                        <div className={styles.conceptDescription__infoBox}>
                            <div className={styles.conceptDescription__info}>
                                <h3 className={styles.info__title}>
                                    {t(
                                        'aboutUs.conceptDescription.conceptDescriptionTitle'
                                    )}
                                </h3>
                                <ul className={styles.info__steps}>
                                    {conceptDescriptionSteps.map(({ step }) => {
                                        return (
                                            <li
                                                key={step}
                                                className={styles.info__step}
                                            >
                                                {step}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>

                            <div className={styles.conceptDescription__info}>
                                <h3 className={styles.info__title}>
                                    {t(
                                        'aboutUs.conceptDescription.theDefiningFeatures.theDefiningFeaturesTitle'
                                    )}
                                </h3>
                                <ul className={styles.info__steps}>
                                    {definingFeatures.map(({ step }) => {
                                        return (
                                            <li
                                                key={step}
                                                className={styles.info__step}
                                            >
                                                {step}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>

                        <div className={styles.conceptDescription__pics}>
                            {pics.map(({ desktopSrc, id }) => {
                                return (
                                    <div
                                        key={id}
                                        className={
                                            styles.conceptDescription__pic
                                        }
                                    >
                                        <AnimatedImg>
                                            <OptimizedImg
                                                desktopSrc={desktopSrc}
                                                mobileSrc={desktopSrc}
                                            />
                                        </AnimatedImg>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Element>
        </section>
    );
};
